import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ToursService } from "./tours.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { TourListModel } from "../../api-models/Tour";
import { ToursMainComponent } from "./tours.main.component";
import { PermissionService } from "@impacgroup/angular-oauth-base";

@Component({
    selector: "app-tours",
    templateUrl: "./tours.component.html",
    styleUrls: ["tours.component.scss"],
    standalone: false
})
export class ToursComponent extends BaseMaterialDatatableComponent<TourListModel> implements OnInit {
    public UTCDATEFORMAT: string = "";
    public hasToursEditPermission = false;

    rows: TourListModel[] = [];

    constructor(
        private toursService: ToursService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        private permissionService: PermissionService,
        parent: ToursMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: toursService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_organizations_list",
            },
            sortState: {
                active: "fromDate",
                direction: "desc",
            },
            displayedColumns: ["name", "fromDate", "toDate", "visited", "createdByMail", "actions"],
            listService: toursService,
        });

        this.permissionService.hasPermission("TOURS.EDIT")
        this.UTCDATEFORMAT = this.toursService.UTCDATEFORMAT;
    }

    addTour() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editTour(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deleteTour(id: string) {
        const initialState = {
            title: this.translateService.instant("tours.list.delete.title"),
            message: this.translateService.instant("tours.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.toursService.delete(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("tours.list.delete.success"));
                    this.loadData();
                })
            );
        };
    }

    duplicateTour(id: string, name: string) {
        this.subscriptions.push(
            this.toursService.duplicate(id, this.translateService.instant("tours.list.duplicate.postfix", { originalName: name })).subscribe((result) => {
                this.alertService.addSuccess(this.translateService.instant("tours.list.duplicate.success"));
                this.editTour(result._id);
            })
        );
    }
}
